/* eslint-disable react/prop-types */
import React from 'react';
import { connect } from 'react-redux';
import Tracking from './Tracking';
import { invoiceSetTrafficSource } from '../../actions/invoices';

const mapDispatchToProps = (dispatch: any) => ({
  setInvoiceTrafficSource: (source: any) => {
    dispatch(invoiceSetTrafficSource(source));
  },
});

const ConnectedTracking = connect(null, mapDispatchToProps)(Tracking);

const action = (context: any, params: any) => ({
  chunks: ['tracking'],

  component: <ConnectedTracking requestUrl={params[0]} />,
  accountWrapper: {
    loginRequired: false,
    nonBlocking: true,
  },
});

export default action;

if (module.hot) {
  module.hot.accept();
}
